import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useContextApi } from "../../../../context/ContextApi";
import uRLs from "../../../../utils/baseUtils";
import { useAuth } from "../../../../context/AuthProvider";
import { handleUnitNameSelect } from "../../../../utils/unitUtils";
import { AddIcon, CloseIcon } from "../../../../constants/Icons";

const NewStock = ({
  data,
  // addToCart,
  onAdd,
  onClose,
}) => {
  const [inputValues, setInputValues] = useState({
    soldprice: CurrencyConverter.toCurrency(data.saleprice || 0, "INR"),
    qty: "1",
  });
  const { settings } = useAuth();
  const { useEscapeKey } = useContextApi();
  useEscapeKey(onClose);
  const [soldPriceError, setSoldPriceError] = useState("");
  const [errors, setErrors] = useState({});
  const soldPriceRef = useRef(null);
  const qtyInputRef = useRef(null);
  const buttonRef = useRef(null);
  const [unitData, setUnitData] = useState();
  const [selectedUnit, setSelectedUnit] = useState();
  useEffect(() => {
    setInputValues({
      soldprice: CurrencyConverter.toCurrency(
        data.cIndex !== undefined
          ? data.soldprice || data.saleprice || 0
          : data.saleprice || 0,
        "INR"
      ),
      qty: data.quantity ? String(data.quantity) : "1",
    });

    setTimeout(() => {
      if (data?.cIndex !== undefined) {
        soldPriceRef.current?.focus();
        soldPriceRef.current?.select();
      } else {
        qtyInputRef.current?.focus();
        qtyInputRef.current?.select();
      }
    }, 0);
  }, [data]);

  const handleUnitName = (unitData) => {
    handleUnitNameSelect(unitData,settings);;
  };

  const handleSalePriceInputChange = (value) => {
    const mrp = CurrencyConverter.toCurrency(data.mrp || 0, "INR");
    let parsedValue = value.replace(/[^0-9.]/g, "");

    const numericValue = parseFloat(parsedValue);

    if (numericValue > mrp) {
      parsedValue = mrp.toString();
    }

    setInputValues((prev) => ({
      ...prev,
      soldprice: parsedValue,
    }));

    if (parsedValue !== "" && !isNaN(numericValue)) {
      setSoldPriceError("");
    }
  };
  const handleQtyInputChange = (value) => {
    let error = "";

    // default => integer only
    let regex = /^\d*$/;

    // primary unit => 3 decimal
    if (
      data?.unitConfig &&
      selectedUnit === data?.unitConfig?.primaryUnitCode
    ) {
      regex = /^\d*\.?\d{0,3}$/;
    }

    // secondary unit => 1 decimal
    else if (
      data?.unitConfig &&
      selectedUnit === data?.unitConfig?.secondaryUnitCode
    ) {
      regex = /^\d*\.?\d{0,1}$/;
    }

    // stop invalid typing
    if (!regex.test(value)) return;

    let numericValue = parseFloat(value);

    // === Step 1: General upper limit ===
    if (!isNaN(numericValue) && numericValue > 999999) {
      numericValue = 999999;
      value = "999999";
    }

    // === Step 2: Edit mode limit ===
    if (data.cMode === "EDIT") {
      const maxQuantity = data?.quantity || 0;

      if (!isNaN(numericValue) && numericValue > maxQuantity) {
        numericValue = maxQuantity;
        value = String(maxQuantity);
      }
    }

    // === Step 3: Stock limit ===
    else if (
      data?.cIndex !== undefined &&
      data.isStock &&
      !isNaN(numericValue) &&
      numericValue > data.stockLeft
    ) {
      numericValue = data.stockLeft;
      value = String(data.stockLeft);
    }

    // === Step 4: Update quantity ===
    setInputValues((prev) => ({
      ...prev,
      qty: value,
    }));

    // === Step 5: Update errors ===
    setErrors((prevErrors) => {
      const updated = { ...prevErrors };

      if (error) {
        updated.qty = error;
      } else {
        delete updated.qty;
      }

      return updated;
    });
  };

  const handleUnitConversion = (unitName, type) => {
    if (unitName === selectedUnit) return;

    setSelectedUnit(unitName);
    if (uRLs.UNIT === "true") {
      if (type === "p") {
        setInputValues((prev) => ({
          ...prev,
          qty: 0,
        }));
      } else if (type === "s") {
        setInputValues((prev) => ({
          ...prev,
          qty: 0,
        }));
      }
    }
  };
  const handleAdd = () => {
    const { soldprice, qty } = inputValues;
    const numericSoldPrice = parseFloat(soldprice);
    const numericQty = Number(qty);

    // if (!soldprice || isNaN(numericSoldPrice) || numericSoldPrice <= 0) {
    //   setSoldPriceError("Enter a valid sale price.");
    //   soldPriceRef.current?.focus();
    //   return;
    // }

    // if (numericSoldPrice > data.mrp) {
    //   setSoldPriceError("Sale price cannot exceed MRP.");
    //   soldPriceRef.current?.focus();
    //   return;
    // }

    if (!qty || isNaN(numericQty) || numericQty <= 0.0) {
      setErrors({ qty: "Enter a valid quantity." });
      qtyInputRef.current?.focus();
      return;
    }

    const newItem = {
      _id: data._id,
      code: data.code,
      hsnsac: data.hsnsac,
      title: data.title,
      mrp: data.mrp,
      saleprice: data.saleprice,
      soldprice: CurrencyConverter.toSubunit(numericSoldPrice, "INR"),
      taxpercentage: data.taxpercentage,
      baseprice: data.baseprice,
      discount: data?.discount || 0,
      taxamount: data?.taxamount || 0,
      isLock: data.isLock,
      isStock: data.isStock,
      quantity: numericQty,
      unitConfig: data?.unitConfig,
      selectedUnitCode: selectedUnit,
      // ...(data.cIndex !== undefined && { cIndex: data.cIndex }),
    };

    onAdd(newItem);
    onClose();
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  useEffect(() => {
    const currentItem = data;

    if (currentItem?.unitConfig) {
      setSelectedUnit(currentItem?.unitConfig?.primaryUnitCode || "");
      const name = handleUnitName(currentItem.unitConfig);

      setUnitData({
        ...currentItem.unitConfig,
        primaryUnitName: name?.primaryUnitName,
        secondaryUnitName: name?.secondaryUnitName,
      });
    } else {
      setUnitData(null);
      setSelectedUnit(null);
    }
  }, [data]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">New Direct Stock</h6>

              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <h6 className="mb-2 bg-text">
                  <span className="badge rounded-pill bg-label-navy">
                    {data.code}
                  </span>{" "}
                  - {data.title}
                </h6>
              </div>

              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="text-center">MRP</th>
                    <th className="text-center">Sale Price</th>
                    <th className="text-center">Tax(%)</th>
                    {data.cMode !== "EDIT" &&
                      data?.cIndex !== undefined &&
                      data.isStock && (
                        <th className="text-center">Stock left</th>
                      )}
                    <th className="text-center w-15">Qty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center align-middle">
                      <div className="py-2">
                        ₹{CurrencyConverter.toCurrency(data.mrp || 0, "INR")}
                      </div>
                    </td>
                    <td className="text-center">
                      <span className="badge bg-label-food rounded-pill">
                        ₹{inputValues?.soldprice}
                      </span>
                    </td>
                    {/* <td className="text-center wx-200">
                      <input
                        type="text"
                        name="soldprice"
                        autoComplete="off"
                        className="form-control text-center"
                        value={inputValues.soldprice}
                        disabled
                        onChange={(e) =>
                          handleSalePriceInputChange(e.target.value)
                        }
                        onFocus={() => {
                          setSoldPriceError("");
                          soldPriceRef.current?.select();
                        }}
                        ref={soldPriceRef}
                        maxLength={String(data.mrp).length + 2}
                      />
                      {soldPriceError && (
                        <div className="invalid-feedback d-block text-center">
                          {soldPriceError}
                        </div>
                      )}
                    </td> */}
                    <td className="text-center">
                      <span className="badge rounded-pill bg-label-peace">
                        {data.taxpercentage ? `${data.taxpercentage}%` : "0%"}
                      </span>
                    </td>
                    {data.cMode !== "EDIT" &&
                      data?.cIndex !== undefined &&
                      data.isStock && (
                        <td className="text-center">
                          <span className="badge bg-label-space">
                            {data?.stockLeft}
                          </span>
                        </td>
                      )}
                    <td // className="wx-150"
                    >
                      <div
                        className="input-group"
                        style={{
                          width: "140px",
                          flexWrap: "nowrap",
                        }}
                      >
                        <input
                          type="text"
                          name="quantity"
                          autoComplete="off"
                          className="form-control text-center"
                          ref={qtyInputRef}
                          value={inputValues.qty || ""}
                          onFocus={() => {
                            qtyInputRef.current?.select();
                          }}
                          onChange={(e) => handleQtyInputChange(e.target.value)}
                          onKeyDown={handlePaymodeKeyDown}
                          maxLength={6}
                        />
                        {uRLs.UNIT === "true" && data?.unitConfig && (
                          <div className="d-flex text-start ">
                            <button
                              className="btn btn-unit shadow-none    rounded-start-0  dropdown-toggle-split"
                              // id="printreceiptbtn"
                              // data-bs-toggle="dropdown"
                            >
                              {selectedUnit}
                            </button>
                            {/* <button
                          type="button" 
                          className="btn btn-unit shadow-none  dropdown-toggle dropdown-toggle-split rounded-start-0 border-start-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        />
                        <ul className="dropdown-menu dropdown-menu-end">
                         
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.primaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              qtyInputRef.current.focus();
                               handleUnitConversion(unitData?.primaryUnitCode,'p')
                             }}
                           >
                             {unitData?.primaryUnitName} ({unitData?.primaryUnitCode})
                           </button>
                         </li>
                         {unitData?.secondaryUnitName && (
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.secondaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              qtyInputRef.current.focus();
                               handleUnitConversion(unitData?.secondaryUnitCode,'s')
                             }}
                           >
                             {unitData?.secondaryUnitName} ({unitData?.secondaryUnitCode})
                           </button>
                         </li>
                         )}
                        </ul> */}
                          </div>
                        )}
                      </div>
                      {errors.qty && (
                        <div className="invalid-feedback d-block text-center">
                          {errors.qty}
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              <button
                ref={buttonRef}
                type="button"
                className="btn btn-teal text-right"
                onClick={handleAdd}
              >
                <AddIcon/> New Stock
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewStock;
